/*
|--------------------------------------------------------------------------
| Utilities: 3rd Party iframes
|--------------------------------------------------------------------------
*/
/**
 * Lazy load 3rd party iframes
 * @memberof utilities
 * @namespace utilities.3rdPartyIframes
 * @inner
 */
__gh__webApp.utilities["3rdPartyIframes"] = {
	
	/**
	 * Initialize
	 * @memberof utilities.3rdPartyIframes
	 * @method init
	 */
	"init": function(){
		this.bindEvents();
	},
	
	
	/**
	 * Load an iframe when it's in view
	 * @memberof utilities.3rdPartyIframes
	 * @method loadIframe
	 */
	"loadIframe": function(){
		var $3rdPartyIframe = $("[data-3rd-party-iframe-src]").first();

		//Check to see if iframe is within 300px
		if ($3rdPartyIframe.length && $3rdPartyIframe.isOnScreen(500)){

	    	var src = $3rdPartyIframe.data("3rd-party-iframe-src");
	    		$3rdPartyIframe.attr("src",src);
				$3rdPartyIframe.removeAttr("data-3rd-party-iframe-src");
	    }
	},
	
	
	/**
	 * Register Handlebars Helpers
	 * @memberof utilities.3rdPartyIframes
	 * @method bindEvents
	 * @example
	 * &lt;iframe height="250" scrolling="no" data-3rd-party-iframe-src="/section/iframe?template=newsmax"&gt;&lt;/iframe&gt;
	 */
	"bindEvents": function(){
		$(document).on("scroll.3rd-party-iframes",this.loadIframe);
	}
};